(function () {
  "use strict";

  angular
    .module("irricrops")

    .filter("decimal", function () {
      return function (input, rounded, defaultCero) {
        if (!isFinite(input)) {
          return "";
        }
        var v = _.round(input, rounded || 2);
        return defaultCero !== undefined && v == 0 ? defaultCero : v;
      };
    })

    .filter("floor", function () {
      return function (input) {
        return Math.floor(input);
      };
    })

    .filter("unsafe", [
      "$sce",
      function ($sce) {
        return function (value) {
          return $sce.trustAs("html", value);
        };
      },
    ])

    .filter("nospace", function () {
      return function (value) {
        return !value ? "" : value.replace(/ /g, "");
      };
    })

    //https://stackoverflow.com/questions/21503588/angularjs-bind-html-string-with-custom-style
    .filter("trusted", [
      "$sce",
      function ($sce) {
        return function (html) {
          return $sce.trustAsHtml(html);
        };
      },
    ])

    .filter("hours", function () {
      return function (value) {
        var m = moment.duration(parseFloat(value), "hours");
        return (
          Math.floor(m.asHours()) +
          ":" +
          (m.minutes() < 10 ? "0" : "") +
          m.minutes()
        );
      };
    })

    /*
     http://stackoverflow.com/questions/18095727/limit-the-length-of-a-string-with-angularjs
     Usage:
     {{some_text | cut:true:100:' ...'}}

     Options:

     wordwise (boolean) - if true, cut only by words bounds,
     max (integer) - max length of the text, cut to this number of chars,
     tail (string, default: ' …') - add this string to the input string if the string was cut.
     */
    .filter("truncate", function () {
      return function (value, wordwise, max, tail) {
        if (!value) return "";

        max = parseInt(max, 10);
        if (!max) return value;
        if (value.length <= max) return value;

        value = value.substr(0, max);
        if (wordwise) {
          var lastspace = value.lastIndexOf(" ");
          if (lastspace != -1) {
            value = value.substr(0, lastspace);
          }
        }

        return value + (tail || " …");
      };
    })

    .filter("initials", function () {
      return function (value) {
        if (!value) return "";
        var words = value.split(" ");
        angular.forEach(words, function (word, index) {
          words[index] = word.slice(0, 1);
        });

        return words.join("");
      };
    })

    .filter("dateString", function () {
      return function (value, format) {
        if (!value) return "";
        return moment(value).format(format);
      };
    })

    //https://tutorialedge.net/javascript/angularjs/removing-duplicates-from-ng-repeat/
    .filter("unique", function () {
      // we will return a function which will take in a collection
      // and a keyname
      return function (collection, keyname) {
        // we define our output and keys array;
        var output = [],
          keys = [];

        // we utilize angular's foreach function
        // this takes in our original collection and an iterator function
        angular.forEach(collection, function (item) {
          // we check to see whether our object exists
          var key = item[keyname];
          // if it's not already part of our keys array
          if (keys.indexOf(key) === -1) {
            // add it to our keys array
            keys.push(key);
            // push this item to our final output array
            output.push(item);
          }
        });
        // return our array which should be devoid of
        // any duplicates
        return output;
      };
    });
})();
